export const COOKIE_CONSENT_KEY = 'cookie-consent';
export const COOKIE_CONSENT_CHANGED_EVENT = 'cookie-consent-changed';

export interface CookieConsent {
  analytics: boolean;
  timestamp: string;
}

export function getConsent(): CookieConsent | null {
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as CookieConsent;
  } catch {
    return null;
  }
}

export function setConsent(analytics: boolean): void {
  const consent: CookieConsent = {
    analytics,
    timestamp: new Date().toISOString(),
  };
  localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(consent));
  window.dispatchEvent(
    new CustomEvent<CookieConsent>(COOKIE_CONSENT_CHANGED_EVENT, { detail: consent }),
  );
}

export function hasConsentChoice(): boolean {
  return getConsent() !== null;
}
